import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { HasAccess } from "@/components/common/has-access";
import {
  ProfessionalStatus,
  professionalStatusLabels,
} from "../schema/professional-schema";
import ChangeStatusDialog from "./change-status-dialog";
import ProfessionalStatusHistory from "./professional-status-history";

type Props = {
  professionalId: string;
  professionalName: string;
  initialStatus: string;
};

// Current status, the "Change status" action and the history, shown on the
// edit drawer. Status is deliberately not part of the edit form (RH-506).
export default function ProfessionalStatusPanel({
  professionalId,
  professionalName,
  initialStatus,
}: Props) {
  const [status, setStatus] = useState<ProfessionalStatus>(
    initialStatus as ProfessionalStatus
  );
  const [open, setOpen] = useState(false);

  const variant =
    status === ProfessionalStatus.ACTIVE
      ? "active"
      : status === ProfessionalStatus.FULLY_DISMISSED
      ? "destructive"
      : "secondary";

  return (
    <div className="py-5 px-6 border-b border-gray-200">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <h4>Status</h4>
          <Badge variant={variant}>
            {professionalStatusLabels[status] ?? status}
          </Badge>
        </div>
        <HasAccess permission="write">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => setOpen(true)}
          >
            Change status
          </Button>
        </HasAccess>
      </div>

      <div className="mt-4">
        <p className="text-xs uppercase tracking-wide text-gray-500 mb-2">
          History
        </p>
        <ProfessionalStatusHistory professionalId={professionalId} />
      </div>

      <ChangeStatusDialog
        open={open}
        onOpenChange={setOpen}
        professionalId={professionalId}
        professionalName={professionalName}
        currentStatus={status}
        onChanged={setStatus}
      />
    </div>
  );
}
